export default __webpack_public_path__ + "maps-examples-fly-to-1200-67052674b7c0a429ef39e93e9159e520.png";